import { ArrowsWrapper, DatePickerWrapper, MainWrapper, MenuWrapper } from './booking-calendar-navigation.style'
import { Button, DatePicker, Typography, theme } from 'antd'
import { LoadingOutlined, ReloadOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import { useTranslate , addDays, getDateRange, useWindowDimensions, queryClient, timezoneFormatter } from 'utils'
import { useConfig, useCurrentLocation } from 'api'
import dayjs from 'dayjs'
import { BookingAction, BookingPageDispatch, BookingPageState } from 'pages/booking/booking-page/booking-page'
import { BOOKING_CALENDAR_NAVIGATION_Z_INDEX } from 'z-indexes'
import { useEffect, useState } from 'react'
import { VerticalContainer } from 'components/styled'
const { Text } = Typography

type Props = {
    pageState: BookingPageState
    pageStateDispatch: BookingPageDispatch
}

export const BookingCalendarNavigation = ({ pageState, pageStateDispatch }: Props) => {

    //hooks:
    const { token: { fontSizeSM, fontSizeLG, colorTextDescription } } = theme.useToken()
    const { LG } = useWindowDimensions()
    const { __ } = useTranslate()
    const { data: config } = useConfig()
    const { data: currentLocation } = useCurrentLocation()
    const timezone = currentLocation ? currentLocation.timezone : config ? config.settings.timezone : null

    //state:
    const [ isRefreshSelected, setIsRefreshSelected ] = useState(false)

    // disable refresh button loading for other fetches:
    useEffect(() => { !pageState.areSlotsLoading && setIsRefreshSelected(false) }, [pageState])
    
    return (!config || !timezone) ? null : (
        <MainWrapper
            top={LG ? 60 : 0}
            zIndex={BOOKING_CALENDAR_NAVIGATION_Z_INDEX}
        >

            <VerticalContainer style={{ gap: 0 }}>
            
                {/* date range */}
                <Text style={{ fontSize: fontSizeLG, fontFamily: 'inter-medium' }}>
                    {getDateRange(pageState.startDate, pageState.numberOfDays, config, false)}
                </Text>

                {/* timezone */}
                <Text style={{ fontSize: fontSizeSM, color: colorTextDescription }}>
                    {timezoneFormatter(timezone)}
                </Text>

            </VerticalContainer>

            <MenuWrapper>

                <DatePickerWrapper>

                    {/* date picker */}
                    <DatePicker
                        inputReadOnly
                        defaultValue={dayjs(pageState.startDate)}
                        value={dayjs(pageState.startDate)}
                        allowClear={false}
                        style={{ width: '100%' }}
                        onChange={val => setStartDate(dayjs(val).toDate(), pageStateDispatch)}
                    />

                    <ArrowsWrapper>

                        {/* left arrow */}
                        <Button
                            icon={<LeftOutlined style={{ fontSize: fontSizeSM }}/>}
                            title={__`previous_day`}
                            size={'middle'}
                            style={{ fontSize: fontSizeSM, backgroundColor: 'transparent' }}
                            onClick={() => setStartDate(addDays(pageState.startDate, -pageState.numberOfDays), pageStateDispatch)}
                        />
                        
                        {/* right arrow */}
                        <Button
                            icon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                            title={__`next_day`}
                            size={'middle'}
                            style={{ fontSize: fontSizeSM, backgroundColor: 'transparent' }}
                            onClick={() => setStartDate(addDays(pageState.startDate, +pageState.numberOfDays), pageStateDispatch)}
                        />

                        {/* refresh */}
                        <Button
                            icon={(pageState.areSlotsLoading && isRefreshSelected) ? <LoadingOutlined style={{ fontSize: fontSizeSM }}/> : <ReloadOutlined style={{ fontSize: fontSizeSM }}/>}
                            title={__`refresh`}
                            size={'middle'}
                            style={{ fontSize: fontSizeSM, backgroundColor: 'transparent' }}
                            onClick={() => {
                                setIsRefreshSelected(true)
                                queryClient.invalidateQueries(['bookingSlots'])
                            }}
                        />
                        
                    </ArrowsWrapper>

                </DatePickerWrapper>

            </MenuWrapper>

        </MainWrapper>
    )
    
}

//setStartDate:
export const setStartDate = (start: Date, pageStateDispatch: BookingPageDispatch) => {
    pageStateDispatch({ type: BookingAction.SET_START_DATE, payload: { startDate: start } })
}
